import { useStreamPlaybackHotkeys } from '../hooks/playback/useStreamPlaybackHotkeys';

/**
 * Component that registers playback-dependent hotkeys.
 * Must be rendered inside PlaybackProvider.
 */

export function StreamPlaybackHotkeysHandler() {
  useStreamPlaybackHotkeys();
  return null;
}
